import type { DaySoldCardProps } from './types'
import { CardTitle, ValueWrapper, StickyBottomWrapper } from '../common/styles'
import { DaySoldCardContainer } from './styles'
import { ProgressRow } from '../ProgressRow'
import { calculatePercentage, getProgressColor } from '../common/utils'
import { formatPrice } from '../../../../../../utils/format'
import { formatDate } from './utils'

export const DaySoldCard = ({
  daySoldValue = 0,
  dayGoalValue = 0
}: DaySoldCardProps) => {
  const percentage = calculatePercentage(daySoldValue, dayGoalValue)
  const progressColor = getProgressColor(percentage)
  const formattedDate = formatDate(new Date())

  return (
    <DaySoldCardContainer>
      <CardTitle>{`VENDAS DO DIA - ${formattedDate}`}</CardTitle>

      <ValueWrapper>
        {formatPrice(daySoldValue)}
      </ValueWrapper>

      <StickyBottomWrapper>
        <ProgressRow
          leftValue={dayGoalValue}
          leftFormat="currency"
          rightValue={percentage}
          rightFormat="percentage"
          rightColor={progressColor}
          progressValue={percentage}
          progressColor={progressColor}
        />
      </StickyBottomWrapper>
    </DaySoldCardContainer>
  )
}
